<template>
  <div class="album-create">
    <h3>Create a new album</h3>
    Name:<br />
    <input :disabled="creating" v-model="name" @keyup.enter="create"> <button :disabled="creating || !name" v-on:click="create">Create</button>
    <div v-if="creating">Please wait...</div>
    <div v-if="created">Success!</div>
    <div v-if="error">Error! {{error.message}}</div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      creating: false,
      created: false,
      error: null,
      name: '',
    }
  },
  methods: {
    create() {
      if (!this.name){
        return
      }
      this.creating = true
      this.created = false
      this.error = null
      axios.post('/api/albums', { name: this.name }).then(response => {
        this.created = true
        setTimeout(() => this.created = false, 2000)
        this.name = ''
        const album = response.data.album
        this.$store.commit('createAlbum', album)
      }).catch(error => {
        this.error = error
      }).then(() => {
        this.creating = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.album-create
  padding-top 25px

input
  width 100%
  margin-bottom 8px
  margin-top 2px

button
  float right

.albums-mobile

  h3
    color #054350
</style>
